import React, { useState } from "react";
import { Button } from "antd";
import { PlusOutlined, FilterOutlined } from "@ant-design/icons";
import TableFilter from "./TableFilter";
import { useLocations } from "../../hooks/useLocation"; // Import the hook to fetch locations

interface TableHeaderProps {
  onAddTable: () => void;
  onApplyFilters: (filters: Record<string, any>) => void;
  onClearFilters: () => void;
  canAddTable: boolean; // Add permission prop
  canSeeAllLocations: boolean; // Add location permission prop
}

const TableHeader: React.FC<TableHeaderProps> = ({
  onAddTable,
  onApplyFilters,
  onClearFilters,
  canAddTable,
  canSeeAllLocations,
}) => {
  const [showFilters, setShowFilters] = useState(false);

  // Fetch locations from API
  const { data: locations, isLoading: locationsLoading } = useLocations();

  // Prepare location options for the filter dropdown
  const locationOptions =
    locations?.map((loc) => ({
      value: loc.id,
      label: loc.name,
    })) || [];

  const allFilterFields = [
    {
      key: "number",
      label: "Table Number",
      type: "text" as const,
    },
    {
      key: "location_id",
      label: "Location",
      type: "select" as const,
      options: locationOptions,
      loading: locationsLoading,
      requiresPermission: true,
    },
    {
      key: "is_booked",
      label: "Availability Status",
      type: "select" as const,
      options: [
        { value: "0", label: "Free" },
        { value: "1", label: "Occupied" },
      ],
    },
    // {
    //   key: "created_at",
    //   label: "Date Range",
    //   type: "dateRange",
    // },
  ];

  // Filter out location field if user doesn't have permission
  const filterFields = allFilterFields.filter(
    (field) => !field.requiresPermission || canSeeAllLocations
  );

  return (
    <div className="mb-6">
      <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-4 space-y-4 lg:space-y-0">
        <div className="flex items-center space-x-2">
          <h1 className="text-lg lg:text-xl font-bold">Table Management</h1>
        </div>

        <div className="flex space-x-3">
          {/* Only show Add Table button if user has permission */}
          {canAddTable && (
            <Button
              type="default"
              onClick={onAddTable}
              icon={<PlusOutlined />}
              className="border border-primary text-primary"
            >
              Add New Table
            </Button>
          )}
          <Button
            icon={<FilterOutlined />}
            onClick={() => setShowFilters(!showFilters)}
          >
            Filters
          </Button>
        </div>
      </div>

      {showFilters && (
        <TableFilter
          fields={filterFields}
          onApplyFilters={onApplyFilters}
          onClearFilters={onClearFilters}
        />
      )}
    </div>
  );
};

export default TableHeader;
